{
  "_comment": "[CI-LOCKED] Selle faili sisu on lukus. Panused on teretulnud, kuid muudatuste valideerimine võib aega võtta.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Robot $1 ütles:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "Te ütlesite:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Manustatud robot:",
  "ACTIVITY_CODE_ALT": "Koodinäidis: $1",
  "ACTIVITY_CONTENT_CAUTION": "Tehisintellekti poolt loodud sisu ei pruugi olla õige",
  "ACTIVITY_CODE_CAUTION": "Kood on tehisintellekti genereeritud. Vaadake see üle ja kasutage ettevaatusega",
  "ACTIVITY_ERROR_BOX_TITLE": "Tõrketeade",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Klõpsake kasutamiseks.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Sõnum on interaktiivne.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Sõnumis on vähemalt üks link.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Saatmine nurjus.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Manustasite:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 manus.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 manust.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 manust.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 manust.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 manust.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Saatmine nurjus. [Proovi uuesti][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Saatmine",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Saadetud kell $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Just praegu",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Tund tagasi",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Minut tagasi",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Täna",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Eile",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Kohandatava kaardi sõelumise tõrge",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Kohandatava kaardi renderdamise tõrge",
  "ATTACHMENT_AUDIO": "Heliklipp.",
  "ATTACHMENT_CARD": "Kaart: $1 $2 $3",
  "ATTACHMENT_FILE": "Fail: $1",
  "ATTACHMENT_IMAGE": "Pilt",
  "ATTACHMENT_TEXT": "Tekst: $1",
  "ATTACHMENT_VIDEO": "Videoklipp",
  "AVATAR_ALT": "$1 avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Järgmine",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Eelmine",
  "CITATION_MODEL_DIALOG_ALT": "Tsitaat",
  "CLOSE_BUTTON_ALT": "Sule",
  "COLLAPSIBLE_GROUPING_TITLE": "Mõtlen…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "See kuvatakse, kui bot koostab rühmas vastussõnumeid, kui kokkuvõtet pole esitatud.",
  "COLLAPSE_BUTTON_LESS": "Kuva vähem",
  "COLLAPSE_BUTTON_LESS.comment": "See on rööpnoolenupu tekst sõnumirühma ahendamiseks. Kui lõppkasutaja klõpsab nuppu, ahendatakse sõnumirühm.",
  "COLLAPSE_BUTTON_MORE": "Kuva rohkem",
  "COLLAPSE_BUTTON_MORE.comment": "See on rööpnoolenupu tekst sõnumirühma laiendamiseks. Kui lõppkasutaja klõpsab nuppu, laiendatakse sõnumirühm.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Ühendatud",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Ühenduse loomine…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Ühendamine nurjus.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Ilmnes võrgukatkestus. Uuesti ühendamine…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Renderdamise tõrge. Kontrollige konsooli või pöörduge roboti arendaja poole.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Ühenduse loomiseks läheb tavapärasest kauem aega.",
  "CONNECTIVITY_STATUS_ALT": "Ühenduse olek: $1",
  "COPY_BUTTON_TEXT": "Kopeeri",
  "COPY_BUTTON_COPIED_TEXT": "Kopeeritud",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Esita",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Tühista",
  "FEEDBACK_FORM_PLACEHOLDER": "Olge kirjeldamisel võimalikult üksikasjalik, ent ärge kaasake privaatset ega delikaatset teavet.",
  "FEEDBACK_FORM_TITLE": "Kirjeldage kasutuskogemust",
  "FILE_CONTENT_ALT": "„$1“",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Laadi alla fail „$1“",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Laadi alla fail „$1” mahuga $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "„$1” mahuga $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Avab uues aknas; väline.",
  "RECEIPT_CARD_TAX": "Maks",
  "RECEIPT_CARD_TOTAL": "Kokku",
  "RECEIPT_CARD_VAT": "KM",
  "REFERENCE_LIST_HEADER_ONE": "$1 viide",
  "REFERENCE_LIST_HEADER_FEW": "$1 viidet",
  "REFERENCE_LIST_HEADER_MANY": "$1 viidet",
  "REFERENCE_LIST_HEADER_OTHER": "$1 viidet",
  "REFERENCE_LIST_HEADER_TWO": "$1 viidet",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Kustuta manus $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Kustuta",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Fail",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Pilt",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Tühja sõnumit ei saa saata.",
  "SPEECH_INPUT_LISTENING": "Kuulamine…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon väljas",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon sees",
  "SPEECH_INPUT_STARTING": "Algus…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Järgmine",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Eelmine",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Soovitatavad tegevused",
  "TEXT_INPUT_ALT": "Sõnumi sisestuse väli",
  "TEXT_INPUT_PLACEHOLDER": "Tippige oma sõnum",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Hakake rääkima...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Kuulamine...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Töötlemine...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Rääkige katkestamiseks...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Saada",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Räägi",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Laadi fail üles",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefoniklahvistik",
  "TEXT_INPUT_DROP_ZONE": "Kukuta failid",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Sõnumi pikkusepiir on ületatud",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Toetab ainult ühekohalist sisendit",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 manust",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 manust",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 manus",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 manust",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 manust",
  "TOAST_ACCORDION_FEW": "$1 teatist: üksikasjade kuvamiseks klõpsake siin",
  "TOAST_ACCORDION_MANY": "$1 teatist: üksikasjade kuvamiseks klõpsake siin",
  "TOAST_ACCORDION_OTHER": "$1 teatist: üksikasjade kuvamiseks klõpsake siin",
  "TOAST_ACCORDION_TWO": "$1 teatist: üksikasjade kuvamiseks klõpsake siin",
  "TOAST_ALT_ERROR": "Tõrge",
  "TOAST_ALT_INFO": "Teave",
  "TOAST_ALT_SUCCESS": "Tehtud",
  "TOAST_ALT_WARN": "Hoiatus",
  "TOAST_DISMISS_BUTTON": "Sule",
  "TOAST_TITLE_ALT": "Teatis",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Vestluse ajalugu, navigeerimiseks vajutage nooleklahvi.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "vestluse ajalugu",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Sõnum on interaktiivne. Vestluse ajaloo avamiseks vajutage 2–3 korda tõstu- ja tabeldusklahvi. Seejärel klõpsake suhtlemiseks sõnumit.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Sõnumis on vähemalt üks link. Vestluse ajaloo avamiseks vajutage 2–3 korda tõstu- ja tabeldusklahvi. Seejärel klõpsake suhtlemiseks sõnumit.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Sõnumil on soovitatavad tegevused. Nende valimiseks vajutage 2–3 korda klahvi Shift.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Sõnumil on soovitatavad tegevused. Nende valimiseks vajutage $1.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Sõnumi saatmine nurjus.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Saadaval on uued sõnumid. Fookuse viimiseks nupule „$2“ vajutage klahvi $1.",
  "TRANSCRIPT_MORE_MESSAGES": "Rohkem sõnumeid",
  "TRANSCRIPT_NEW_MESSAGES": "Uued sõnumid",
  "TRANSCRIPT_TERMINATOR_TEXT": "Vestluse ajaloo lõpp",
  "TYPING_INDICATOR_ALT": "Tippimise näidiku kuvamine",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 kirjutab.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 ja teised kirjutavad.",
  "VIEW_CODE_BUTTON_TEXT": "Kood",
  "VOTE_COMPLETE_ALT": "Tagasiside on salvestatud",
  "VOTE_COMPLETE_ALT.comment": "See on ekraanilugeri jaoks. Üles- ja allapoole osutava pöidla ikoonidega nupu silt. Silti kasutatakse tagasiside salvestamisel.",
  "VOTE_DISLIKE_ALT": "Ei meeldi",
  "VOTE_LIKE_ALT": "Meeldib"
}